import {Injectable, signal} from '@angular/core';

@Injectable({providedIn: 'root'})
export class SmModalStackService {
  private readonly dialogs: {dialog: HTMLDialogElement; order: number}[] = [];
  private readonly overlays: {owner: object; close: () => void; order: number}[] = [];
  private nextOrder = 0;
  readonly popupActive = signal(false);

  openedOverlay(owner: object, close: () => void): void {
    const index = this.overlays.findIndex(entry => entry.owner === owner);
    if (index >= 0) this.overlays.splice(index, 1);
    this.overlays.push({owner, close, order: ++this.nextOrder});
    this.syncActive();
  }

  closedOverlay(owner: object): void {
    const index = this.overlays.findIndex(entry => entry.owner === owner);
    if (index >= 0) this.overlays.splice(index, 1);
    this.syncActive();
  }

  closeTopOverlay(): boolean {
    const entry = this.overlays[this.overlays.length - 1];
    if (!entry) return false;
    const activeDialogs = this.dialogs.filter(item => item.dialog.open && item.dialog.isConnected);
    const topDialogOrder = activeDialogs.length ? activeDialogs[activeDialogs.length - 1].order : -1;
    if (entry.order < topDialogOrder) return false;
    entry.close();
    this.syncActive();
    return true;
  }

  opened(dialog: HTMLDialogElement): void {
    const index = this.dialogs.findIndex(item => item.dialog === dialog);
    if (index >= 0) this.dialogs.splice(index, 1);
    this.dialogs.push({dialog, order: ++this.nextOrder});
    this.syncActive();
  }

  closed(dialog: HTMLDialogElement): void {
    const index = this.dialogs.findIndex(item => item.dialog === dialog);
    if (index >= 0) this.dialogs.splice(index, 1);
    this.syncActive();
  }

  top(): HTMLDialogElement | null {
    while (this.dialogs.length) {
      const dialog = this.dialogs[this.dialogs.length - 1].dialog;
      if (dialog.open && dialog.isConnected) return dialog;
      this.dialogs.pop();
    }
    this.syncActive();
    return null;
  }

  private syncActive(): void {
    this.popupActive.set(this.overlays.length > 0 || this.dialogs.some(item => item.dialog.open && item.dialog.isConnected));
  }
}
